// console.log('Tada');

// Function to add default language object to note_attributes
function addDefaultLanguageToNoteAttributes() {
    // Define the default language object
    var defaultLanguage = {
        name: 'language',
        value: 'en' // Replace 'en' with your desired default language code
    };

    // Check if cart attributes already contain the language attribute
    var existingAttributes = Shopify.cart.note_attributes || [];
    var languageExists = existingAttributes.some(function(attribute) {
        return attribute.name === 'language';
    });

    // If language attribute doesn't exist, add it
    if (!languageExists) {
        existingAttributes.push(defaultLanguage);
    }

    // Update the cart attributes
    Shopify.cart.updateNoteAttributes(existingAttributes, function(cart) {
        console.log('Note attributes updated:', cart.note_attributes);
    });
}

// Call the function when a product is added to the cart
$(document).on('click', '[data-add-to-cart]', function() {
    addDefaultLanguageToNoteAttributes();
});
